export function formatMoney(value) {
  if (typeof value !== 'number') {
    return value;
  }

  // const positive = Math.abs(value);

  return '$' + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  // return '$' + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}
